import styled from "styled-components";

export const VersionSelectionContainer = styled.div`
  width: 200px;
  margin-right: 10px;
`;
